import { render, staticRenderFns } from "./BookingHeading.vue?vue&type=template&id=cec2d718&"
import script from "./BookingHeading.vue?vue&type=script&lang=js&"
export * from "./BookingHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports